import { render, staticRenderFns } from "./TeachersTableSample.vue?vue&type=template&id=5769ac76&"
import script from "./TeachersTableSample.vue?vue&type=script&lang=js&"
export * from "./TeachersTableSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports